module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingOpenpointofsale.9a25164c.png";